// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"header-primaryButton-3vRGiM","container":"header-container-2RrNun","dropdown":"header-dropdown-2Ex-Hr","dropdownLabel":"header-dropdownLabel-2um7cJ"};